import React from 'react';
import { Button, Icon, Box, Menu, Portal } from '@chakra-ui/react';
import { ArrowsUpDownIcon } from '@heroicons/react/24/outline';

interface Props {
  sortKey: string;
  onSortChange: (value: string) => void;
}

const SortItems = [
  { value: 'recent', label: 'Recent' },
  { value: 'titleAsc', label: 'Title A-Z' },
  { value: 'titleDesc', label: 'Title Z-A' },
];

const Sort: React.FC<Props> = ({ sortKey, onSortChange }) => {
  return (
    <Menu.Root>
      <Menu.Trigger asChild>
        <Button colorPalette='brand' variant='ghost' size='sm'>
          <Icon as={ArrowsUpDownIcon} w={4} h={4} />
          <Box display={{ base: 'none', md: 'block' }}>
            Sort by {SortItems.find((item) => item.value === sortKey)?.label}
          </Box>
          <Box display={{ base: 'block', md: 'none' }}>
            {SortItems.find((item) => item.value === sortKey)?.label}
          </Box>
        </Button>
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner zIndex={1500}>
          <Menu.Content minW='10rem'>
            <Menu.RadioItemGroup value={sortKey} onValueChange={(e) => onSortChange(e.value)}>
              {SortItems.map((item) => (
                <Menu.RadioItem key={item.value} value={item.value}>
                  {item.label}
                </Menu.RadioItem>
              ))}
            </Menu.RadioItemGroup>
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};

export default Sort;
